module.exports = __webpack_public_path__ + "img/protelBanner2.cc3e00b2.jpg";